import {useTranslation} from "react-i18next";
import {Button, Card, Dropdown, Form, Input, Menu} from "antd";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import {DataGridProvider} from "../../core/components/data-grid/DataGridContext";
import HospitalGrid from "../../app/hospital/hospital-data-grid/HospitalGrid";
import HospitalFilter from "../../app/hospital/hospital-data-grid/HospitalFilter";
import Flex from "../../core/components/Flex";
import CardTitle from "../../core/components/CardTitle";
import {useEffect} from "react";
import AppConfig from "../../core/service/AppConfig";
import {useModal} from "../../core/context/ModalContext";
import {useDataGrid} from "../../core/components/data-grid/DataGridContext";
import HospitalCreateEdit from "../../app/hospital/HospitalCreateEdit";
import GridFilterCard from "../../core/components/data-grid/GridFilterCard";

export default function HospitalGridPage()
{
    const {t} = useTranslation();

    useEffect(() => {
        document.title = `${t('Hospitals')} | ${AppConfig.getRisTitle()}`
    }, []);

    // Rendered inside DataGridProvider (as the Card title), so it can refresh the grid.
    const Title = () => {
        const {openModal, closeModal} = useModal();
        const {refreshDataGrid} = useDataGrid();

        return (
            <Flex justifyContent={'space-between'}>
                <CardTitle title={t('Hospitals')} />
                <Button
                    onClick={() => {
                        openModal(t('Create Hospital'), (
                            <HospitalCreateEdit
                                onSaved={() => {
                                    closeModal();
                                    refreshDataGrid();
                                }}
                            />
                        ))
                    }}
                >
                    {t('New Hospital')}
                </Button>
            </Flex>
        )
    }

    return (
        <>
            <DataGridProvider>
                {/* Filtre az alanlı: yan panel yerine grid'in üstünde ayrı kart. */}
                <LayoutWithSider fullWidth={true}>
                    <GridFilterCard>
                        <HospitalFilter/>
                    </GridFilterCard>
                    <Card title={<Title />}>
                        <HospitalGrid />
                    </Card>
                </LayoutWithSider>
            </DataGridProvider>
        </>
    )
}
